"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ResourceList_1 = __importDefault(require("../ResourceList"));
const Hotspot_1 = __importDefault(require("../models/Hotspot"));
const Account_1 = __importDefault(require("../models/Account"));
const Reward_1 = __importDefault(require("../models/Reward"));
const Sums_1 = __importStar(require("./Sums"));
const Validator_1 = __importDefault(require("../models/Validator"));
class Rewards {
    constructor(client, context) {
        this.client = client;
        this.context = context;
    }
    async list(params) {
        var _a, _b;
        const { data: { data: rewards, cursor }, } = await this.client.get(this.baseUrl, {
            cursor: params.cursor,
            min_time: params.minTime instanceof Date ? (_a = params.minTime) === null || _a === void 0 ? void 0 : _a.toISOString() : params.minTime,
            max_time: params.maxTime instanceof Date ? (_b = params.maxTime) === null || _b === void 0 ? void 0 : _b.toISOString() : params.maxTime,
            bucket: params.bucket,
        });
        const data = rewards.map((d) => new Reward_1.default(this.client, d));
        return new ResourceList_1.default(data, this.list.bind(this), cursor);
    }
    get sum() {
        return new Sums_1.default(this.client, Sums_1.SumsType.rewards, this.context);
    }
    get baseUrl() {
        let url = '';
        if (this.context instanceof Hotspot_1.default) {
            url = `/hotspots/${this.context.address}/rewards`;
        }
        else if (this.context instanceof Account_1.default) {
            url = `/accounts/${this.context.address}/rewards`;
        }
        else if (this.context instanceof Validator_1.default) {
            url = `/validators/${this.context.address}/rewards`;
        }
        else {
            throw new Error('invalid context');
        }
        return url;
    }
}
exports.default = Rewards;
//# sourceMappingURL=Rewards.js.map